<template>
  <div>
    <v-card>
      <!-- init passo-->
      <v-card-text v-if="onboarding == 0 || onboarding">
        <v-container grid-list-xl class="form-analise-credito">
          <v-flex xs12>
            <p class="titulo">Upload de Documentos</p>
          </v-flex>
          <anexo-list-component
            :documentosSolicitados.sync="pendenciasCopia"
            :classColuna="'lg4 md6 sm12'"
            :mostraDescricao="true"
            :mostraTitulo="true"
            @send="setUpdateDocumentos"
            @setDocumentosModel="this.solicitarAnalise"
          ></anexo-list-component>
        </v-container>
      </v-card-text>
      <!-- end passo -->
    </v-card>

    <v-layout row wrap pt-4>
      <v-flex text-xs-right>
        <v-btn
          class="button jns-button yellow-button no-margin-top"
          @click="avancar()"
        >
          Solicitar Análise</v-btn
        >
      </v-flex>
    </v-layout>

    <v-dialog v-model="documentosSucessoModal" :max-width="'640'">
      <base-modal>
        <h3>Formulário enviado para análise com sucesso!</h3>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8 pb-0>
            <v-btn
              class="button jns-button yellow-button mt-4"
              @click="fecharModalSucesso()"
              >OK</v-btn
            >
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <v-dialog v-model="documentosErrorModal" :max-width="'640'">
      <base-modal>
        <h2 class="headline">{{ responseError.title }}</h2>
        <br />
        <p class="description" v-html="responseError.message"></p>
        <p>Detalhes: {{ responseError.details }}</p>

        <v-flex xs4 offset-xs8 pb-0>
          <v-btn
            class="button jns-button yellow-button mt-4"
            @click="fecharModalSucesso()"
            >OK</v-btn
          >
        </v-flex>
      </base-modal>
    </v-dialog>
  </div>
</template>

<script lang="js">
import { eventBus } from "../main";
import { formatDate, maskCnpj, isValidCpf, isValidCnpj } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "ProcessoAnaliseCredito",
  mixins: [ViewMixin],
  data() {
    return {
      maskCnpj,
      grupoEconomicoMask: "##.###.###/####-##",
      pendenciasCopia: [],
      bancos: [],
      categoriasPeps: [],
      passos: 0,
      onboarding: 0,
      dataFundacaoFormatter: null,
      documentosSucessoModal: false,
      documentosErrorModal: false,
      responseError: {
        title: '',
        details: '',
        message: ''
      },
      dataFundacaoMenu: false,
      temGrupoEconomico: false,
      temAvalista: false,
      rules: {
        obrigatorio: (v) => !!v || "Campo obrigatório",
        cepIvalido: (v) =>
          new RegExp("\\d{5}[-]\\d{3}").test(v) || "Cep inválido",
        cpfInvalido: (v) =>
          (!!v && isValidCpf(v)) || "Documento inválido",
        cnpjInvalido: (v) =>
          (!!v && isValidCnpj(v)) || "Documento inválido",
        documentoInvalido: (v) =>
          (!!v &&
            (v.length > 14
              ? isValidCnpj(v)
              : isValidCpf(v))) ||
          "Documento inválido",
        email: (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail inválido",
        telefone: (v) =>
          /^(\([0-9]{2}\))\s([9]{1})?([0-9]{4})-([0-9]{4})$/.test(v) ||
          "Telefone inválido",
      },
    };
  },
  props: {
    item: Object,
    pendencias: Array,
    route: { type: String, default: "POST_REVISAO_CREDITO" },
    slug: String,
  },
  methods: {
    async getCategoriasPep() {
      var data = [];
      try {
        data = await this.$store.dispatch("GET_CATEGORIAS_PEP");
      } catch (e) {
        this.setErrorModal(e.response.data);
        return;
      }

      if (data)
        for (var i = 0; i < data.length; i++)
          this.categoriasPeps.push({
            id: data[i].id,
            descricao: data[i].descricao,
            enumerador: i + 1,
            tooltipShow: false,
          });
    },

    async getBankList() {
      try {
        this.bancos = await this.$store.dispatch("GET_BANK");
      } catch (e) {
        this.setErrorModal(e.response.data);
      }
    },

    geraDataFundacao(){
      let dataAtual = new Date();
      let dataFundacao = dataAtual.toLocaleDateString('pt-BR').split('/');
      dataFundacao[2] = dataFundacao[2] - 3;
      return dataFundacao.reverse().join('-');
    },

    async solicitarAnalise(modelDocumentos) {

      var model = {
        documento: this.item.documento ? this.item.documento : null,
        razao_social: this.item.razao_social ? this.item.razao_social : null,
        nome_fantasia: this.item.nome_fantasia ? this.item.nome_fantasia : 'Não informado',
        telefone: this.item.telefone ? this.item.telefone.replace(/[^\d]+/g, "") : '9999999999',
        email: this.item.email ? this.item.email : 'naopossuiemail@email.com',
        website: this.item.website ? this.item.website : null,
        interveniente_coobrigado: this.temAvalista
          ? this.item.interveniente_coobrigado
          : null,
        dados_bancarios: this.item.dados_bancarios ? this.item.dados_bancarios : null,
        endereco: {
          logradouro: this.item.endereco.logradouro ? this.item.endereco.logradouro : null,
          bairro: this.item.endereco.bairro ? this.item.endereco.bairro : null,
          cidade: this.item.endereco.cidade ? this.item.endereco.cidade : null,
          uf: this.item.endereco.uf ? this.item.endereco.uf : null,
          cep: this.item.endereco.cep ? this.item.endereco.cep.replace(/[^\d]+/g, "") : null,
        },
        grupo_economico: {
          nome: this.item.grupo_economico.nome ? this.item.grupo_economico.nome : this.item.razao_social,
          documento: this.item.grupo_economico.documento ? this.item.grupo_economico.documento.replace(/[^\d]+/g, "") : this.item.documento,
          socio_majoritario: this.item.grupo_economico.socio_majoritario ? this.item.grupo_economico.socio_majoritario : true,

        },
        fundacao: this.item.fundacao ? this.item.fundacao : this.geraDataFundacao(),
        representantes_legais: [],
        documentos: modelDocumentos,
      };

      this.item.representantes_legais.forEach((element) => {
        var item = {
          nome: element.nome,
          documento: element.documento.replace(/[^\d]+/g, ""),
          cargo: element.cargo,
          email: element.email,
          pep: element.pep,
          categorias_pep: [],
        };

        element.categorias_pep.forEach((elementCat) => {
          item.categorias_pep.push({ id: elementCat.id });
        });

        model.representantes_legais.push(item);
      });

      try {
        this.showLoadingIndicator();
        let payload = {};
        if (this.route == "POST_REVISAO_CREDITO")
          payload = {
            propostaId: this.$route.params.propostaId,
            produtoId: this.$route.params.produtoId,
            model: model,
          };
        else
          payload = {
            model: model,
          };

        await this.$store.dispatch(this.route, payload);

        this.documentosSucessoModal = true;
      } catch (e) {
        this.documentosErrorModal = true
        let response = e.response.data
        this.responseError = {
          title:response.title,
          details: response.details,
          message: response.message
        }

      } finally {
        this.hideLoadingIndicator();

      }
    },
    avancar() {
      var isValid = true;

      switch (this.onboarding) {
        case 0:
          if (this.validaAnexos()) eventBus.$emit("setModelAnexos");
          else this.$forceUpdate();
          break;
      }
    },

    fecharModalSucesso() {
      if (this.route == "POST_REVISAO_CREDITO") this.$router.go();
      else {
        this.documentosSucessoModal = false;
        this.$forceUpdate();

        this.$emit("solicitarLimites", this.item);
      }
    },

    next() {
      this.onboarding =
        this.onboarding + 1 === this.length ? 0 : this.onboarding + 1;
    },

    prev() {
      if (this.onboarding == 0)
        this.$emit("fecharAnaliseCreditoModal", this.item);
      this.onboarding =
        this.onboarding - 1 < 0 ? this.length - 1 : this.onboarding - 1;
    },

    setDataFormat() {
      this.dataFundacaoFormatter = formatDate(this.item.fundacao);
      this.$forceUpdate();
    },
    setDocumentos() {
      const categoriasPermitidas = ["OBRIGATÓRIOS", "ADICIONAIS/COMPLEMENTARES"];

      this.pendenciasCopia = this.pendencias.filter((categoria) => categoriasPermitidas.includes(categoria.categoria));
    this.$forceUpdate();
  },
    setUpdateDocumentos(data) {

      this.pendenciasCopia = data;
      this.$forceUpdate();
    },

    validaCategoriaPep(i) {
      var isValid = true;

      if (this.item.representantes_legais[i].pep)
        if (
          !this.item.representantes_legais[i].categorias_pep_selected ||
          this.item.representantes_legais[i].categorias_pep_selected.length == 0
        ) {
          this.item.representantes_legais[i].hasError = true;
          isValid = false;
        } else this.item.representantes_legais[i].hasError = false;

      return isValid;
    },

    validaAnexos() {

      var isValid = true;

      this.pendenciasCopia.forEach((categoria) => {
        if (categoria.listagem && categoria.listagem.length) {
          for (var i = 0; i < categoria.listagem.length; i++) {
            if (
              (!categoria.listagem[i].arquivos ||
                !categoria.listagem[i].arquivos.length) &&
              categoria.listagem[i].obrigatorio
            )
              isValid = false;
          }
        }
      });
      if (!isValid) eventBus.$emit("validaAnexos");

      return isValid;
    },

  },
  created() {
    if (this.item.cnpj_cpf) {
      this.item.documento = this.item.cnpj_cpf;
      this.item.razao_social = this.item.nome;
    }
    if (!this.item.dados_bancarios) this.item.dados_bancarios = {};
    this.getCategoriasPep();
    this.getBankList();
  },
  beforeMount() {
    if (this.item.fundacao)
      this.dataFundacaoFormatter = formatDate(this.item.fundacao);
    if (!this.item.grupo_economico)
      this.item.grupo_economico = { socio_majoritario: false };
    this.temGrupoEconomico = !this.item.grupo_economico.socio_majoritario;
    if (this.temGrupoEconomico) this.grupoEconomicoMask = "##.###.###/####-##";
    else this.grupoEconomicoMask = "###.###.###-##";
    this.temAvalista =
      !!this.item.interveniente_coobrigado || this.slug != "TRADICIONAL";

    if (this.pendencias && this.pendencias.length) {
      this.setDocumentos();
      if (!this.pendenciasCopia || !this.pendenciasCopia.length) this.passos--;
    } else this.passos--;

    if (!this.item.representantes_legais) this.item.representantes_legais = [];
  },
  watch: {
    temGrupoEconomico: function (value) {
      this.item.grupo_economico.socio_majoritario = !value;

      if (value) this.grupoEconomicoMask = "##.###.###/####-##";
      else this.grupoEconomicoMask = "###.###.###-##";
    },
    temAvalista: function (value) {
      if (!value) this.item.interveniente_coobrigado = null;
    },
    onboarding: function (value) {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 959px) {
  .container {
    padding: 0.5vh 1vh !important;
  }
}

@media only screen and (min-width: 960px) {
  .container {
    max-width: 100% !important;
  }
}

.v-card__title {
  padding: 7vh 0 2vh 0;
  justify-content: center;

  .headline {
    font-weight: 900;
    font-size: 3vh !important;
    color: #061d45;
  }
}

.v-card__actions {
  .v-btn--active:before {
    background-color: transparent;
  }

  i {
    font-size: 1.5vh;
    color: #282498;
  }
}

.v-card__text {
  overflow: auto;
}

.blue-button {
  margin: 6px 8px !important;
}

.v-btn {
  text-transform: none;
}

.button {
  max-width: 25vh;
}

.container,
.v-card__actions {
  padding: 1vh 5vh;
}

.container {
  padding: 0.5vh 5vh !important;
}

.step-analise-credito {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// ./src/components/ProcessoAnaliseCredito.vue